import React from "react";
import ClipsGroup from "../../components/Clips/ClipsGroup";
import { ClipPage } from "../../components/Clips/Clip.elements";

const ClipsPage = (props) => {
  return (
      <ClipPage>
        <ClipsGroup currentUser={props.currentUser} />
      </ClipPage>
  );
};

export default ClipsPage;
